import React, { SyntheticEvent, useEffect, useState } from 'react';
import filtersStyles from '../../Filters.module.scss';
import { CloseLight, Action } from 'esa-ui-library';
import { useStore } from '../../../../../common';
import { PropertyType } from 'esa-ui-library/lib/types';
import { FilterDropdown } from '../FilterDropdown/FilterDropdown';
import { getActiveLabels, getFilterValue, getUpdateOptions, selectPreselectedOptions } from '../../Filters.helper';
import { cloneDeep, find } from 'lodash';
import useFilters from '../../../../../common/hooks/useFilters';

const SessionStatusFilter = (): JSX.Element => {
	const [{ sessionStatuses, filters }] = useStore();
	const [filterOptions, setFiltersOptions] = useState<PropertyType[]>([]);
	const { onFilter } = useFilters();

	const onFilterChange = (option: PropertyType) => {
		const updateOptions = getUpdateOptions(option, filterOptions);
		const filterValue = getFilterValue(updateOptions);

		onFilter([{ name: 'session_statuses', value: filterValue }]);
	};

	const onFilterRemove = (e: SyntheticEvent) => {
		e.stopPropagation();
		onFilter([{ name: 'session_statuses', value: '' }]);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels(filterOptions);
		if (!activeLabels.length) return 'All';

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onFilterRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	useEffect(() => {
		if (sessionStatuses) {
			setFiltersOptions(cloneDeep(sessionStatuses));
		}
	}, [sessionStatuses]);

	useEffect(() => {
		const filter = find(filters, ['name', 'session_statuses'])?.value || '';
		setFiltersOptions(selectPreselectedOptions(sessionStatuses, filter));
	}, [filters]);

	return (
		<Action
			label='Status'
			labelContent={getLabelContent()}
			select
			className={`${filtersStyles.Filter} 
			${getActiveLabels(filterOptions).length ? filtersStyles.Active : ''} `}
			dataId='status-filter'
		>
			<FilterDropdown data={filterOptions} onChange={onFilterChange} isSearchable />
		</Action>
	);
};

export { SessionStatusFilter };
